import store from 'store/index';
import _ from 'lodash';
_.noConflict();

function fillChannelInfo (stats) {
  return stats.map(row => {
    const channel = store.getters['channels/getChannelById'](row.channel_id) || {};
    return {...row, channel_name: channel.display_name || ''};
  });
}

function postprocessWidgetData (widget, rawData) {
  let data = rawData;

  /*
   * filter non selected labels, because backend returns statistics for filtered labels
   * and labels which are intersected with labels
   */
  if (widget.dsStatisticsParams && widget.dsStatisticsParams.grouping === 'label') {
    if (widget.dsStatisticsParams.filteringType === 'label') {
      const labels = widget.dsStatisticsParams.filterEntities;
      const labelsSet = new Set(labels);
      data[0].items = data[0].items.filter(r => labelsSet.has(r.label_name));
    }
  }

  let processed = {
    data: data[0],
    lastPeriodData: {items: [], total: {}}
  };

  if (widget.type === 'metricChart') {
    processed = {
      data: data[0],
      lastPeriodData: {total: data[1].items[0] || {}}
    };
  }

  if (widget.type === 'periodsComparisonChart') {
    processed.data.items.forEach(i => {
      i.periodToCompare = 'firstPeriod';
    });
    if (data[1]) {
      data[1].items.forEach(i => {
        i.periodToCompare = 'secondPeriod';
      });
      processed.data.items.push(...data[1].items);
    }
  }

  if (widget.dsStatisticsParams && widget.dsStatisticsParams.grouping === 'channel') {
    processed.data.items = fillChannelInfo(processed.data.items);
  }

  return processed;
}

export default postprocessWidgetData;
